import React, { useEffect, useState } from "react";
import bloodpressure from "../../assets/images/bloodpressure.png";
import heartrate from "../../assets/images/heart.png";
import pulse from "../../assets/images/pulserate.png";
import weight from "../../assets/images/Svg/weight.svg";
import respiration from "../../assets/images/Svg/oxygen.svg";
import bmi from "../../assets/images/bmi.png";
import temperature from "../../assets/images/temp.png";
import vitals1 from "../../assets/images/linechart.jpg";
import VitalService from "../../Services/VitalService";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { Tooltip } from "antd";
import moment from "moment";
import { HSdecrypt } from "../../utils/encryptPassword";
const colors = ["rgb(54, 162, 235)", "rgb(75, 192, 192)", "rgb(255, 99, 132)"];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "white",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      >
        <p style={{ margin: 0, color: "black" }}>{`${label}`}</p>
        {payload.map((entry, index) => (
          <p key={index} style={{ margin: 0, color: entry.color }}>
            {`${entry.name}: ${entry.value}`}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

function HealthTrends(props) {
  const [vitalCode, setVitalCode] = useState("BP");
  const [vitalName, setVitalName] = useState("Blood Pressure");
  const [vitalsData, setVitalsData] = useState([]);
  const [vitalsData1, setVitalsData1] = useState([]); // For BPD

  useEffect(() => {
    MyVitalList();
  }, [vitalCode]);

  let combinedData = [];
  if (vitalCode === "BP") {
    const bpsData = vitalsData.map((d) => ({
      date: moment(d.recordedDateTime).format("MM/DD"),
      BPS: d.value,
    }));

    const bpdData = vitalsData1.map((d) => ({
      date: moment(d.recordedDateTime).format("MM/DD"),
      BPD: d.value,
    }));

    // Merge BPS and BPD data by date
    combinedData = bpsData.map((bps) => {
      const bpd = bpdData.find((bpd) => bpd.date === bps.date);
      return {
        date: bps.date,
        BPS: bps.BPS,
        BPD: bpd ? bpd.BPD : null, // Ensure data exists for BPD
      };
    });
    combinedData = combinedData.reverse();
  } else {
    combinedData = vitalsData
      .map((d) => ({
        date: moment(d.recordedDateTime).format("MM/DD"),
        value: d.value,
        name: d.vitalName,
      }))
      .reverse(); // Reverse for other vitals too
  }

  const MyVitalList = () => {
    let payload = {
      patientId: props?.selectedPatient,
      vitalCodes: vitalCode !== "BP" ? vitalCode : "BPS",
    };

    if (vitalCode === "BP") {
      let payload1 = {
        patientId: props?.selectedPatient,
        vitalCodes: "BPD",
      };

      Promise.all([
        VitalService.HSgetVitalsData(payload),
        VitalService.HSgetVitalsData(payload1),
      ])
        .then(([bpsResult, bpdResult]) => {
          const decryptedbpsData = JSON.parse(HSdecrypt(bpsResult.data.data));
          const decryptedbpdData = JSON.parse(HSdecrypt(bpdResult.data.data));
          setVitalsData(decryptedbpsData?.slice(0, 5)); // For BPS
          setVitalsData1(decryptedbpdData?.slice(0, 5)); // For BPD
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      VitalService.getVitalsData(payload)
        .then((result) => {
          setVitalsData(result?.data?.slice(0, 5));
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const images = [
    {
      id: 1,
      src: bloodpressure,
      alt: "Image 1",
      title: "Blood Pressure",
      content: vitals1,
      vitalCode: "BP",
      vitalName: "Blood Pressure",
    },
    {
      id: 2,
      src: heartrate,
      alt: "Image 2",
      title: "Heart Rate",
      content: "This is the content for Image 2.",
      vitalCode: "HR",
      vitalName: "Heart Rate",
    },
    {
      id: 3,
      src: pulse,
      alt: "Image 3",
      title: "Pulse Oxygen",
      content: "This is the content for Image 3.",
      vitalCode: "PO",
      vitalName: "Pulse Oxygen",
    },
    {
      id: 4,
      src: weight,
      alt: "Image 3",
      title: "Weight",
      content: "This is the content for Image 3.",
      vitalCode: "WE",
      vitalName: "Weight",
    },
    {
      id: 5,
      src: respiration,
      alt: "Image 4",
      title: "Respiration Rate",
      content: "This is the content for Image 4.",
      vitalCode: "RR",
      vitalName: "Respiration Rate",
    },
    {
      id: 6,
      src: bmi,
      alt: "Image 5",
      title: "BMI",
      content: "This is the content for Image 5.",
      vitalCode: "BMI",
      vitalName: "BMI",
    },
    {
      id: 7,
      src: temperature,
      alt: "Image 6",
      title: "Temperature",
      content: "This is the content for Image 6.",
      vitalCode: "TP",
      vitalName: "Temperature",
    },
  ];

  // const handleImageClick = (image) => {
  //   setSelectedImage(image);
  // };

  const handleVitalClick = (code, name) => {
    setVitalCode(code);
    setVitalName(name);
  };

  return (
    <div
      className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
      id="unquie-scroll"
    >
      <div className="flex justify-between items-center p-3">
        <h3 className="text-sm font-bold text-gray-700">Health Trends</h3>
        <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
          {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
        </div>
      </div>
      <hr />
      <div className="h-60 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
        <div className="p-2">
          <div className="flex space-x-4">
            {images.map((img) => (
              <img
                key={img.id}
                src={img.src}
                alt={img.alt}
                className={`w-6 h-6 object-cover cursor-pointer`}
                // onClick={() => handleImageClick(image)}
                onClick={() => handleVitalClick(img?.vitalCode, img?.vitalName)}
              />
            ))}
          </div>
          <div>
            <h2 className="text-sm mt-3 font-bold mb-2">{vitalName}</h2>
            {/* <img src={vitals1} alt="" className="w-full h-40" /> */}
            <ResponsiveContainer width="100%" height={180}>
              <LineChart
                data={combinedData}
                // margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                {/* Line for BP (BPS and BPD) */}
                {vitalCode === "BP" && (
                  <>
                    <Line
                      type="monotone"
                      dataKey="BPS"
                      stroke={colors[0]}
                      name="BPS"
                    />
                    <Line
                      type="monotone"
                      dataKey="BPD"
                      stroke={colors[1]}
                      name="BPD"
                    />
                  </>
                )}
                {/* Single Line for other vitals */}
                {vitalCode !== "BP" && (
                  <Line
                    type="monotone"
                    dataKey="value"
                    stroke={colors[0]}
                    name={combinedData[0]?.name}
                  />
                )}
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
    // <div className="w-full max-w-[370px] h-[300px] sm:h-[340px] md:h-[370px] md:m-5 border rounded-lg">
    //   <div className="header h-[13%] bg-secondaryColor flex items-center justify-center rounded p-2">
    //     <h1 className="font-bold text-normal text-white mt-3">HealthTrends</h1>
    //   </div>
    //   <div className="body h-[75%] overflow-y-auto bg-white scrollwidth border-t-2">
    //     <div className="flex justify-between items-center p-2 m-3 border rounded-md">
    //       <div className="p-2">
    //         <div className="flex space-x-4">
    //           {images.map((img) => (
    //             <img
    //               key={img.id}
    //               src={img.src}
    //               alt={img.alt}
    //               className={`w-6 h-6 object-cover cursor-pointer`}
    //               // onClick={() => handleImageClick(image)}
    //               onClick={() => handleVitalClick(img?.vitalCode, img?.vitalName)}
    //             />
    //           ))}
    //         </div>
    //         <div>
    //           <h2 className="text-sm mt-3 font-bold mb-2">
    //             {vitalName}
    //           </h2>
    //           {/* <img src={vitals1} alt="" className="w-full h-40" /> */}
    //           <ResponsiveContainer width="100%" height={180}>
    //             <LineChart
    //               data={combinedData}
    //               // margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
    //             >
    //               <CartesianGrid strokeDasharray="3 3" />
    //               <XAxis dataKey="date" />
    //               <YAxis />
    //               <Tooltip content={<CustomTooltip />} />
    //               <Legend />
    //               {/* Line for BP (BPS and BPD) */}
    //               {vitalCode === "BP" && (
    //                 <>
    //                   <Line
    //                     type="monotone"
    //                     dataKey="BPS"
    //                     stroke={colors[0]}
    //                     name="BPS"
    //                   />
    //                   <Line
    //                     type="monotone"
    //                     dataKey="BPD"
    //                     stroke={colors[1]}
    //                     name="BPD"
    //                   />
    //                 </>
    //               )}
    //               {/* Single Line for other vitals */}
    //               {vitalCode !== "BP" && (
    //                 <Line
    //                   type="monotone"
    //                   dataKey="value"
    //                   stroke={colors[0]}
    //                   name={combinedData[0]?.name}
    //                 />
    //               )}
    //             </LineChart>
    //           </ResponsiveContainer>
    //         </div>

    //       </div>

    //     </div>
    //   </div>
    //   <div className="footer h-[44px] bg-secondaryColor rounded"></div>
    // </div>
  );
}

export default HealthTrends;
